const metricType = {
  POST_METRIC_DATA: "POST_METRIC_DATA",
  POST_METRIC_DATA_COMMIT: "POST_METRIC_DATA_COMMIT",
  POST_METRIC_DATA_ROLLBACK: "POST_METRIC_DATA_ROLLBACK",
};

export default metricType;
